import AddressHelpers, { Address } from "./address";

export interface BillingAccount {
  id: number;
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  contact_number?: string;
  tax_number?: string;
  addresses?: Address[];
  created_at?: string;
  updated_at?: string;
}

function New(): BillingAccount {
  return { id: 0 };
}

function Clone(acc: BillingAccount): BillingAccount {
  const res: BillingAccount = {
    id: 0,
    name: acc.name,
    first_name: acc.first_name,
    last_name: acc.last_name,
    email: acc.email,
    contact_number: acc.contact_number,
    tax_number: acc.tax_number
  };

  if (acc.addresses) {
    res.addresses = [];
    for (const a of acc.addresses) {
      res.addresses.push(AddressHelpers.Copy(a));
    }
  }

  return res;
}

function DisplayText(acc?: BillingAccount) {
  if (!acc) { return ""; }
  if (acc.name || acc.first_name || acc.last_name) {
    return `${acc.name || ''} ${acc.first_name || ''} ${acc.last_name || ''}`.trim();
  }
  return `${acc.name || acc.email}` || 'No BillingAccount Selected';
}

function ValidBasic(acc?: BillingAccount) {
  if (!acc) { return false; }
  if (acc.first_name && acc.last_name && acc.email && acc.contact_number) { return true; }
  return false;
}

export default {
  New,
  Clone,
  DisplayText,
  ValidBasic,
};
